var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuLeaderboardIcon = function SvgMenuLeaderboardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-diamond-2418983",
    d: "M5.345 0h-.006a.6.6 0 0 0-.458.222L.128 6.163a.6.6 0 0 0 0 .746L12.007 21.52v.005a.594.594 0 0 0 .917 0L24.814 6.91a.595.595 0 0 0 0-.746L20.061.223A.6.6 0 0 0 19.597 0Zm.834 1.188h5.012l-3.556 4.2Zm7.576 0h5.012l-1.456 4.2Zm-1.282.325 3.751 4.428h-7.5Zm-7.338.292L6.569 5.94H1.831Zm14.675 0 3.308 4.135h-4.742ZM1.839 7.128H6.98l3.825 11.029Zm6.4 0h8.467l-4.234 12.207Zm9.725 0h5.142l-8.967 11.029Z"
  })));
};
export default SvgMenuLeaderboardIcon;